import { Icon } from "../../Icon";
import { IIcon } from "../../interfaces/IIcon";

export const talentIcon: IIcon = new Icon(
    `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><rect width="64" height="64" rx="3"/><path fill="#FFF" fill-rule="nonzero" d="M33.816 41V26.89h4.653v-3.023H25.53v3.024h4.653V41z"/></svg>`
);
